import ProductService from "../services/product.service"

function createDownload(response, downloadName) {
    var link = document.createElement("a")
    link.href = URL.createObjectURL(new Blob([response.data]))
    link.download = downloadName
    link.click()
}

export async function downloadImage(product, version, extension, currentLocation, document, setDownload, errorFunction = () => { }) {
    setDownload(true)
    await ProductService.getModuleDownload(product, version, extension)
        .then((response) => {
            if (!currentLocation || (window.location.pathname == currentLocation.pathname)) {
                createDownload(response, `${product}-${version}.${extension}`)
                setDownload(false)
            }
        })
        .catch((error) => {
            errorFunction()
        })
}

export async function downloadDocumentation(path, downloadName) {
    await ProductService.getDocumentationDownload(path)
        .then((response) => {
            createDownload(response, downloadName)
        })
        .catch((error) => {
            
        })
}

const lettersNumbers = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
const specialChars = '!#$%&=+?'
const allChars = lettersNumbers + specialChars

function randomIndex(max) {
    return crypto.getRandomValues(new Uint32Array(1))[0] % max
}

function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
        const j = randomIndex(i + 1)
        const tmp = array[i]
        array[i] = array[j]
        array[j] = tmp
    }
    return array
}

export function generateSecureCode(length = 17) {
    let result = []
    // Ensure at least 2 special characters
    for (let i = 0; i < 2; i++) {
        result.push(specialChars[randomIndex(specialChars.length)])
    }
    for (let i = result.length; i < length; i++) {
        result.push(allChars[randomIndex(allChars.length)])
    }
    return shuffleArray(result).join('')
}